@use 'src/global/variables.scss' as var;

c-avatar-bot {
  .conversation-avatar-bot {
    width: var.$conversation-avatar-size;
    height: var.$conversation-avatar-size;
  }

  .button-avatar-bot {
    display: inline-block;

    @media screen and (max-width: 768px) {
      width: var.$avatar-button-diameter-small;
      height: var.$avatar-button-diameter-small;
    }
    @media screen and (min-width: 769px) {
      width: var.$avatar-button-diameter;
      height: var.$avatar-button-diameter;
    }
  }

  .alert-avatar-bot {
    width: var.$button-diameter;
    height: var.$button-diameter;
  }
}
